import {
  getUserExperiments,
  type UserExperiment,
} from '@otter-ai/recall-client';

export type ExperimentQuery = {
  readonly queryFn: () => Promise<Map<string, UserExperiment>>;
  readonly queryKey: readonly (string | undefined)[];
  readonly staleTime: number;
  readonly cacheTime: number;
};

export const userExperimentsQuery: ExperimentQuery = {
  queryKey: ['user/experiments'],
  queryFn: async () => {
    const resp = await getUserExperiments({ throwOnError: true });
    const expMap = new Map();
    for (const exp of resp.data.experiments) {
      expMap.set(exp.experiment, exp);
    }
    return expMap;
  },
  staleTime: Number.POSITIVE_INFINITY,
  cacheTime: Number.POSITIVE_INFINITY,
} as const;
